module.exports = __webpack_public_path__ + "static/media/how_deliver_watercolor.40aad1c7.png";